import React from "react";
import InfoRow from "../InfoRow";
import { useQuery } from "@tanstack/react-query";
import { getRequest } from "src/api/inventory";
import { format } from "date-fns";
import { cva } from "class-variance-authority";
import CustomDataTable from "../CustomDataTable";

const statusVariants = cva("tw-capitalize tw-font-semibold", {
	variants: {
		status: {
			pending: "tw-text-orange",
			approved: "tw-text-green",
		},
	},
	defaultVariants: {
		status: "default",
	},
});

const columns = [
	{ name: "Product", selector: (row) => row.name, grow: 1.5 },
	{ name: "Requested", selector: (row) => row.requested_quantity },
	{ name: "Approved", selector: (row) => row.approved_quantity },
];

const RequestDetail = ({ requestUUID }) => {
	const { data } = useQuery({
		queryKey: ["requests", requestUUID],
		queryFn: () => getRequest(requestUUID),
		suspense: true,
	});

	const details = data?.data;

	return (
		<div className="tw-flex tw-flex-col tw-gap-3">
			<InfoRow className="tw-capitalize" title="From:">
				{details?.from_name}
			</InfoRow>
			<InfoRow className="tw-capitalize" title="To:">
				{details?.to_name}
			</InfoRow>
			<InfoRow title="Status:">
				<span className={statusVariants({ status: details?.status })}>{details?.status}</span>
			</InfoRow>
			<InfoRow title="Date:">{format(details?.created_at, "PPP")}</InfoRow>
			{/* <InfoRow title="Request Qty:">{details?.requested_qty}</InfoRow>
			<InfoRow title="Approved Qty:">{details?.approved_qty}</InfoRow> */}
			<CustomDataTable containerClassName="tw-mt-10" columns={columns} data={details?.items ?? []} />
		</div>
	);
};

export default RequestDetail;
